import { filterOptions } from '@/utils/query-base'

const all = filterOptions(['EQ', 'EMPTY', 'NE', 'NEMPTY', 'CP', 'BT', 'GT', 'LT', 'LE', 'GE'])

export const pageSearch = {
  'billCode': {
    title: '申请单号',
    type: 'input',
    equation: all
  },
  'partner': {
    title: '客户编码',
    type: 'dialog',
    equation: all,
    dialog: {
      component: 'ClientSelect',
      title: '客户选择'
    }
  },
  'zyxdy': {
    title: '营销中心',
    type: 'select',
    equation: all,
    dictionary: 'sale'
  },
  'zqdlx': {
    title: '渠道类型',
    type: 'select',
    equation: all,
    dictionary: 'goodsPlanType'
  },
  'brand': {
    title: '存货分类',
    type: 'select',
    equation: all,
    dictionary: 'A0019'
  },
  'annual': {
    title: '计划年度',
    type: 'year',
    equation: all
  }
}

export default {
  'partner': {
    title: '客户编码'
  },
  'name': {
    title: '客户名称',
    width: 250
  },
  //'amountAll': {
  //  title: '全年计划量'
  //},
  'brand': {
    title: '存货分类编码'
  },
  'brandName': {
    title: '存货分类描述',
    width: 200
  },
  'zqdlxTextView': {
    title: '渠道类型'
  },
  //'qdjhl': {
  //  title: '渠道初始计划量'
  //},
  'zyxdy': {
    title: '营销单元'
  },
  'zyxdyName': {
    title: '营销单元名称',
    width: 200
  },
  'annual': {
    title: '实际年度'
  },
  'monthly': {
    title: '月份'
  },
  'deliveryNum': {
    title: '计划量'
  },
  'approvingNum': {
    title: '发货量(审核中)'
  },
  'usedNum': {
    title: '发货量(归档)'
  },
  'remainNum': {
    title: '剩余量'
  },
  'operation': {
    title: '操作',
    slot: true
  },
  'billStatusTextView': {
    title: '状态'
  }

}



// WEBPACK FOOTER //
// ./src/views/apply-for-manage/data-searching/config/deliveryPlanQuery.js